// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__DQg3X","imageUploader":"EGiftCard_imageUploader__kRknp"};